'use client';

import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

import CloseIcon from '@/fo/icons/base/icons/close.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';
import { Product } from '@/fo/ui/review/catalog/base';

import { RatingValue, ReviewForm } from '../components';
// import { UserInfo } from '../types';

import { styles } from './FeatureReviewFormBase.styles';

export interface FeatureReviewFormBaseProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  product: Product;
  type: 'review' | 'question';
  ratingId: string;
  ratings: RatingValue[];
  // userInfo?: UserInfo;
}

export function FeatureReviewFormBase({
  onOpenChange,
  open,
  product,
  type,
  ratingId,
  ratings
  // userInfo
}: FeatureReviewFormBaseProps) {
  const t = useTranslations();
  const slots = styles();
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    if (!open) {
      setIsSuccess(false);
    }
  }, [open]);

  const title = t('review.form.title');

  const children = (
    <>
      <div className={slots.header()}>
        {!isSuccess ? <h2 className={slots.title()}>{title}</h2> : <div />}
        <UiKitButtonBase
          color="white"
          rounded="full"
          className={slots.mobileCloseButton()}
          onClick={() => onOpenChange(false)}
        >
          <CloseIcon className={slots.closeIcon()} />
        </UiKitButtonBase>
      </div>

      {type === 'review' && (
        <ReviewForm
          sku={product.id}
          ratingId={ratingId}
          ratings={ratings}
          onSuccess={() => setIsSuccess(true)}
          // userInfo={userInfo}
          onClose={() => onOpenChange(false)}
        />
      )}
    </>
  );

  return (
    <UiKitDrawerBase
      title={title}
      open={open}
      direction="right"
      withoutMobile
      onOpenChange={onOpenChange}
      handleOnly
      contentClassName={slots.content()}
      closeButtonClassName={slots.closeButton()}
    >
      {children}
    </UiKitDrawerBase>
  );
}
